module.exports = __webpack_public_path__ + "static/media/petrichor-frame.23620033.png";